import { render, staticRenderFns } from "./events-with-external-impact.vue?vue&type=template&id=9273ff5e&scoped=true"
import script from "./events-with-external-impact.vue?vue&type=script&lang=js"
export * from "./events-with-external-impact.vue?vue&type=script&lang=js"
import style0 from "./events-with-external-impact.vue?vue&type=style&index=0&id=9273ff5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9273ff5e",
  null
  
)

export default component.exports